import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getCoopDettagliantiGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaCoopDettaglianti);

export const getCoopDettagliantiControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaCoopDettaglianti}.${path}`);
